module.exports = __webpack_public_path__ + "static/cinsa_dimensiones_lineas_claras-b894d4fcaf4a073ab41d5c8d2e2ca520.png";